import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
import mqStore from 'store/mqStore';
import { pauseMotions } from './motion';
export default class MenuPanel extends Component {
    mobile = false;
    category = null;
    motions = [];
    bindEvents(add) {
        const method = bindMethod(add);
        this.refs.links?.forEach((link) => {
            link[method]('mouseover', (e) => this.onLinkOver(e));
            link[method]('mouseout', () => this.onLinkOut());
        });
        this.refs.lists?.forEach((list) => {
            list[method]('mouseout', () => this.onListOut());
        });
        mqStore.narrowDesktop.listenAndStart(this.onMqChange);
    }
    onLinkOver(event) {
        this.refs.links?.forEach((link) => {
            link.classList.remove('active');
            link.classList.add('inactive');
        });
        const link = event.currentTarget;
        link.classList.add('active');
    }
    onLinkOut() {
        if (this.category) {
            this.refs.links?.forEach((link) => {
                if (link.dataset.slug === this.category) {
                    link.classList.remove('inactive');
                    link.classList.add('active');
                }
                else {
                    link.classList.add('inactive');
                    link.classList.remove('active');
                }
            });
        }
        else {
            this.refs.links?.forEach((link) => {
                link.classList.remove('active');
                link.classList.remove('inactive');
            });
        }
    }
    onListOut() {
        if (this.category)
            return;
        this.refs.links?.forEach((link) => {
            link.classList.remove('active');
            link.classList.remove('inactive');
        });
        this.refs.items?.forEach((item) => {
            item.classList.remove('active');
            item.classList.remove('inactive');
        });
    }
    onMqChange = (mobile) => {
        this.mobile = mobile;
    };
    open() { }
    forceOpen() { }
    forceClose() { }
    close() { }
    cancelMotions() {
        pauseMotions(this.motions);
        this.motions = [];
    }
    reset() {
        this.onListOut();
    }
}
